import { LinkContext } from '@anm/contexts/LinkContext';
import { useContext, FC } from 'react';

import { ListItem } from './Wrapper';
import getItemLink from './helpers/getItemLink';
import getPagesList from './helpers/getPagesList';
import { NumberedListProps } from './types';

const NumberedList: FC<NumberedListProps> = ({
  link,
  pagesCount,
  currentPage,
  ...pageListProps
}) => {
  const pageList = getPagesList({ currentPage, pagesCount, ...pageListProps });
  const { Link } = useContext(LinkContext);

  return (
    <>
      {pageList.map((page, index) => {
        const nextElement = pageList[index + 1];
        const nextPage = page + 1;
        const canShowSeperator = nextElement && nextElement !== nextPage;

        const croppedItemLink = getItemLink({
          page,
          link,
          target: 'next'
        });
        const currentItemLink = getItemLink({
          page,
          link,
          target: 'current'
        });

        return (
          <>
            <ListItem isNumber key={page} isSelected={currentPage === page}>
              <Link {...currentItemLink}>{page}</Link>
            </ListItem>
            {canShowSeperator && (
              <ListItem isSeparator key={page + 1}>
                <Link {...croppedItemLink}>...</Link>
              </ListItem>
            )}
          </>
        );
      })}
    </>
  );
};

export default NumberedList;
